/**
 * Staging environment config
 */

const website_domain = "https://www-staging.zoominfo.com";
const base_login_canonical = "https://login-staging.zoominfo.com";
const cookies_domain = ".zoominfo.com";
const app_domain = "https://login-staging.zoominfo.com";
const lb_domain = website_domain;

export const environment = {
  // staging specific configuration
  production: false,
  name: "staging",
  app_domain,
  website_domain,
  base_login_canonical,
  cookies_domain,
  bs_regular_domain: "https://dozi-staging.zoominfo.com/bizservices",
  grow_backend_domain: "https://dozi-staging.zoominfo.com/anura",

  // Login Backend
  lb_domain,
  login_backend_domain: "https://login-staging.zoominfo.com/api",
  new_login_backend_path: "https://login-staging.zoominfo.com/gw/lbe/v2/api",
  is_new_login_backend: true,

  // Amplitude
  amplitude_api_key: "6df4d4fa782dba3adb6191a1b24e4b4f",
  amplitude_proxy_url: 'https://events-stg.zoominfo.com/',
  datadog_rum_application_id: "f1b5aba3-326c-4315-8fed-0c35c8767ff5",  // Datadog Browser RUM application id for login-ui

  ums_password_reset_url: "https://login-staging.zoominfo.com/gw/ziapi/ums/v2/passwordReset",  // NOSONAR
  ums_mfa_webauthn_url: "https://login-staging.zoominfo.com/gw/ziapi/ums/v2/user/external/mfa/webauthn",  // NOSONAR

  sso_redirect_url: "https://gw-app-staging.zoominfo.com/okta/ssoRedirect",
  //
  dozi_url_enterprise: "https://dozi-staging.zoominfo.com",
  dozi_url_community: "https://dozi-staging.zoominfo.com",
  devportal_domain: "https://developer-staging.zoominfo.com/#/",
  dozi_url_reachout: "https://dozi-staging.zoominfo.com/#/reachout/routing",
  dozi_regression_url: "https://dozi-regression.zoominfo.com",
  zi_lite_url: "https://zi-lite-dev.zoominfo.com/#/",
  zi_lite_regression_url: "https://zi-lite-regression.zoominfo.com/",
  essentials_url: "https://essentials-dev.zoominfo.com/#/",
  essentials_regression_url: "https://essentials-regression.zoominfo.com/",
  partners_url: "https://partners-dev.zoominfo.com/#/",
  partners_regression_url: "https://partners-regression.zoominfo.com/",
  //
  zi_url_enterprise: "https://grow-staging.zoominfo.com",
  zi_url_community: "https://grow-staging.zoominfo.com",
  //
  recruiter_url_enterprise: "https://recruiter-app-staging.zoominfo.com",
  recruiter_url_community: "https://recruiter-app-staging.zoominfo.com",
  recruiter_url_reachout:
    "https://recruiter-app-staging.zoominfo.com/reachout/routing",
  talent_engine_url: "https://talent-engine-staging.zoominfo.com",
  talent_autopilot_url: "https://talent-autopilot-staging.zoominfo.com",
  //
  marketing_cloud_url_enterprise: "https://marketingos-staging.zoominfo.com",
  //
  engage_url_enterprise: "https://engage-app-staging.zoominfo.com",
  //
  admin_url_enterprise: "https://admin-dev.zoominfo.com/",
  admin_regression_url: "https://admin-regression.zoominfo.com/",
  //
  tam_url_enterprise: "https://tam-staging.zoominfo.com/",
  //
  operations_url_enterprise: "https://operationsos-stg.zoominfo.com/",
  zi_backoffice_url:
    "https://backoffice-staging.zoominfo.com/backoffice/home/index",
  //
  microsoft_clientId: "29f78c74-171c-44fa-a79f-9c6865c7464f",
  google_clientId:
    "847459799279-6ij2vd0cr1t9atvc4833fjg3171s2bbo.apps.googleusercontent.com",
  GOOGLE_TAG_MANAGER_ID: "GTM-MQM5HKH",
  //okta login configs
  googleIdpId: "0oa23qz2lscj0XW881d7",
  microsoftIdpId: "0oa24cbjtbzQCaIPu1d7",
  sfIdpId: "0oa8gocn2oE3jYMnM1d7",
  oktaClientId: "0oa224kozwgZTpJCM1d7",
  oktaLoginUrl: "https://okta-login-staging.zoominfo.com",
  oktaIssuer: "https://okta-login-staging.zoominfo.com/oauth2/default",
  oktaLegacyIssuer: 'https://zoominfo-ciam-staging.oktapreview.com/oauth2/default',
  sm_ping_url: "https://login-staging.zoominfo.com/gw/ziapi/okta/ping",
  sm_uuid_username_url: "https://login-staging.zoominfo.com/gw/ziapi/usernameFromUuid",
  sm_refresh_storage_url: "https://login-staging.zoominfo.com/gw/ziapi/refreshToken",
  sm_refresh_access_token_url: "https://login-staging.zoominfo.com/gw/ziapi/refreshAccessToken",
  sm_auto_provisioning_login_url: "https://gw-app-staging.zoominfo.com/gw/ziapi/autoProvisioningLogin",
  sm_fraud_detection_url: "https://gw-app-staging.zoominfo.com/gw/ziapi/fraudDetectionFromLogin",
  oktaDeleteSessionUrl: "https://okta-login-staging.zoominfo.com/api/v1/users/me/lifecycle/delete_sessions",
  oktaGetSessionsMeUrl: "https://okta-login-staging.zoominfo.com/api/v1/sessions/me",

  skilljarUrlPartial: 'zoominfo-ciam-staging_skilljarsaml_1',
  // ZI-Lite sign up URL
  signup_url: 'https://signup-dev.zoominfo.com/#/',
  settings_url: 'https://dozi-staging.zoominfo.com/ziapi/settings/api',
  play_store_url: 'https://play.google.com/store/apps/details?id=com.zoominfo.enterprise.staging&hl=en',
  partner_api_url: 'https://gw-app-staging.zoominfo.com/gw/ziapi/api/v1/partner-scope/apps',

  // GTM Studio
  gtm_studio_url: 'https://gtm-studio-dev.zoominfo.com',

  //GTM Copilot
  gtm_copilot_url: 'https://copilot-dev.zoominfo.com/',
  gtm_copilot_regression_url: "https://copilot-regression.zoominfo.com",

  // Studio V2
  studio_v2_url: 'https://gtm-dev.zoominfo.com/',

  // Combined Platform
  combined_platform_url: 'https://gtm-dev.zoominfo.com',
  combined_platform_regression_url: 'https://gtm-regression.zoominfo.com',

  launchDarkly: {
    clientSideId: '61547e7eb0c94d22fc332783',
    options: {
      baseUrl: 'https://app.launchdarkly.com',
      streamUrl: 'https://clientstream.launchdarkly.com',
      eventsUrl: 'https://events.launchdarkly.com',
    },
  }
};
